export default __webpack_public_path__ + "static/media/brandballoon-primary.4ebd5c2e.png";